/**
 * 404 Not Found page component
 */
export function NotFound() {
  return (
    <div className="grow flex flex-col items-center justify-center text-center px-4">
      <h1 className="text-7xl font-bold mb-4 text-muted-foreground">
        404
      </h1>
      <h2 className="text-2xl font-semibold mb-4">Page not found</h2>
      <p className="text-muted-foreground mb-8 max-w-md">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <a 
        href="/" 
        className="px-6 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors font-medium"
      >
        Go back home
      </a>
    </div>
  )
}
